import { ArrowRight, Check, Milk, Sparkles } from 'lucide-react';
import { Col, Container, Row } from 'react-bootstrap';
import '../../../assets/styles/customer/layout/CTASection.css';
import MyButton from '../../../components/common/Button/MyButton';

const CTASection = () => {
  const benefits = [
    'Free to start',
    'No credit card required',
    'Cancel anytime'
  ];

  return (
    <section className="cta-section">
      
      {/* Animated Background */}
      <div className="cta-animated-bg">
        <div className="cta-circle circle-1"></div>
        <div className="cta-circle circle-2"></div>
        <div className="cta-circle circle-3"></div>
      </div>

      {/* Floating Milk Bottles */}
      <div className="cta-floating-bottles">
        <div className="cta-bottle bottle-1">🥛</div>
        <div className="cta-bottle bottle-2">🥛</div>
        <div className="cta-bottle bottle-3">🥛</div>
      </div>

      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            
            <div className="cta-content text-center">
              
              {/* Badge */}
              <div className="cta-badge">
                <Sparkles size={18} />
                <span>Start free, upgrade anytime</span>
              </div>

              {/* Main Heading */}
              <h2 className="cta-heading">
                Ready to Modernize Your <span className="cta-highlight">Dairy Business?</span>
              </h2>

              {/* Description */}
              <p className="cta-description">
                Join hundreds of distributors and thousands of customers already enjoying 
                the benefits of digital milk delivery management.
              </p>

              {/* CTA Buttons */}
              <div className="cta-buttons">
                <MyButton variant="primary" className="cta-primary-btn">
                  Get Started as Customer
                  <ArrowRight size={20} className="ms-2" />
                </MyButton>
                <button className="cta-secondary-btn">
                  <Milk size={20} className="me-2" />
                  Register as Distributor
                </button>
              </div>

              {/* Benefits List */}
              <div className="cta-benefits">
                {benefits.map((benefit, index) => (
                  <div key={index} className="benefit-item">
                    <Check size={18} strokeWidth={2.5} />
                    <span>{benefit}</span>
                  </div>
                ))}
              </div>

            </div>

          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CTASection;